import { put, call, take, fork } from 'redux-saga/effects'
import { courseCloneService } from '../../api/course'
import { courseCloneSuccess } from '../../reducers/collection/action'
import { COURSE_CLONE } from '../../reducers/collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseCloneFlow(payload) {
  try {
    const { code, callback } = payload

    const response = yield call(courseCloneService, code)

    yield put(courseCloneSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseCloneWatcher() {
  while (true) {
    const action = yield take(COURSE_CLONE)
    const { payload } = action

    yield fork(generalSaga, courseCloneFlow, payload)
  }
}
